import type { FetchShortsOptions } from '~/composables/shorts/useFetchShorts';

/**
 * O que cada superfície de shorts pede à API além dos filtros do usuário.
 *
 * Estava espalhado antes: `24` cravado na grade, `15` herdado por omissão do
 * default de `useFetchShorts`, e o fallback de recomendação passado por fora, a
 * cada chamada. Com os dois contratos lado a lado a divergência fica visível e
 * um campo novo do back custa um arquivo.
 */
export interface ShortsSurfaceContract {
	/** Tamanho de página pedido à API de featured-videos. */
	perPage: number;
	/** Opções aplicadas a toda request da lista, inclusive no `loadMore`. */
	fetchOptions: FetchShortsOptions;
}

/** Grade de `/shorts`. */
export const SHORTS_LISTING_SURFACE_CONTRACT: ShortsSurfaceContract = {
	perPage: 24,
	/**
	 * A grade cai na curadoria da home quando a recomendação ancorada em
	 * `referenceProperty` volta vazia, em vez de mostrar estado vazio.
	 */
	fetchOptions: { enableRecommendationFallback: true }
};

/** Feed de `/shorts/[commercialId]`. */
export const SHORTS_FEED_SURFACE_CONTRACT: ShortsSurfaceContract = {
	perPage: 15,
	/**
	 * O feed não cai na curadoria: o fim da recomendação é uma tela própria
	 * (expansão automática e manual) e o fallback a esconderia, porque a API
	 * nunca voltaria vazia.
	 */
	fetchOptions: { enableRecommendationFallback: false }
};
